import addTimelineRefs from "./add-timeline-refs";
import processParentOptionsRefs from "./process-parent-options-refs";

/**
 *
 * @param {MainClassProps} main
 */
const processStorageParentRefs = (main) => {
  const refs = /** @type {Array<Map<String, any>>} */ (
    main.storage.get("parent-refs")
  );

  /** Loop trough "parent" array */
  for (const parent of refs) {
    const process = parent.get("should-process");

    if (process) {
      /** Default data */
      parent.set("enter-percents", 0);
      parent.set("leave-percents", 1);
      parent.set("enter-progress", 0);
      parent.set("leave-progress", 0);
      parent.set("enter-overall", 0);
      parent.set("leave-overall", 0);
      parent.set("percents-overall", 0);
      parent.set("delayed", false);
      parent.set("paused", false);
      parent.set("enter-start-time", null);
      parent.set("leave-start-time", null);
      parent.set("current-iteration", 0);
      parent.set("has-spring", false);
      parent.set("has-alternate", false);
      parent.set("is-alternating", false);
      parent.set("status-1-done", false);
      parent.set("status-2-done", false);
      parent.set("enter", null);
      parent.set("last-progress-array", []);
      parent.set("last-progress", 0);
      parent.set("last-point-x", 0);
      parent.set("last-point-y", 0);
      parent.set("last-point-rotation", 0);
      parent.set("last-start-time", 0);
    }

    processParentOptionsRefs(parent);
    addTimelineRefs(main, parent);
  }
};

export default processStorageParentRefs;
